/* global G */
import { curry } from 'lib/util'
import routeComposition from 'trait/composition/route'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'

/**
 * Event Handler Create Redirect with ACLs
 *
 * Redirects to the first object declared in action.ui.create.routes that fulfills the ACL
 * condition.
 *
 * @example configuration:
 *
 * create: {
 *   handler: 'createWithAcl',
 *   routes: [
 *     {
 *       aclContext: ['!adm', '!csm'],
 *       route: {
 *         action: 'create',
 *       },
 *     },
 *     {
 *       aclContext: ['adm', 'csm'],
 *       route: {
 *         action: 'new',
 *       }
 *     },
 *   ],
 * }
 *
 * @param {Object} module               the current module composition object
 * @param {Object} component            the current component
 * @param {Object} event                the fired event
 * @param {Object} event.detail         the fired event's detail
 * @param {Object} event.detail.routes  the route to redirect to whenever this event is fired
 * @returns {Promise<void>}
 */
const createWithAcl = async (module, component, event) => {
  const aclAdapter = module[G.ADAPTER][G.ACL]
  const { routes } = event.detail

  const { route } = routes.find((route) => {
    const aclRoute = { ...route, aclProps: { failed: true } }
    // context role check
    const roleProps = aclAdapter.contextRole(aclRoute)
    // context check
    const contextProps = aclAdapter.context(aclRoute)

    return !roleProps.failed && !contextProps.failed
  }, {}) || {}

  if (route) {
    try {
      const moduleState = module[G.STATE]
      moduleState[G.ROUTE] = routeComposition(route.module, route.action)
      await redirectSequence(module)({})
    } catch (e) {
      console.error(e)
    }
  }
}

export default curry(createWithAcl)
